<section class="content">
  <div class="card" style="padding:25px">
    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
        <!-- <app-maser-page-header></app-maser-page-header> -->
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="margin-top: 15px;">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;"> S.No.</th>
                <td mat-cell *matCellDef="let element;let i = index"> {{i +1}}</td>
            </ng-container>

            <ng-container matColumnDef="booth_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Business name</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            {{element.business_name | slice:0:10}}
                        </div>

                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="booth_code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Business code</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            {{element.business_code | slice:0:10}}
                        </div>

                    </div>
                </td>
            </ng-container>

            <!-- account holder Column -->
            <ng-container matColumnDef="acc_holder_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Acc. Holder Name</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            {{element.account_holder_name | slice:0:12}}
                        </div>

                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="cheque_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Cheque Number</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            {{element.cheque_number}}
                        </div>

                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="date_of_issue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Date Of Issue</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            {{element.date_of_issue}}
                        </div>

                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="is_cleared">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: silver;">
                    <label class="form-label">Status</label>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="row">
                        <div class="col">
                            <button style="color: green;" *ngIf="element.is_cleared" disabled mat-button color="primary">Cleared</button>
                            <button *ngIf="!element.is_cleared" mat-stroked-button color="warn"
                                (click)="openClearcheque(element)">Approve</button>
                        </div>

                    </div>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    </div>
</section>
